import { toHankakuNumber } from "./StringUtils"

export const parseNumber = <T>(arg: string | number, alternativeIfNaN: T) => {
  const n = Number.parseFloat(toHankakuNumber(arg.toString().trim()))
  return Number.isNaN(n) ? alternativeIfNaN : n
}

const formatter = new Intl.NumberFormat("ja-JP", { maximumFractionDigits: 20 })
export const commaFormat = (num: number) => formatter.format(num)

/**
 * 数値をカンマ区切りして通貨単位を加えた文字列を返します。
 * @example
 * currencyNameFormat(12345); // -> 12,345円
 */
export const currencyNameFormat = (value: number) => {
  return new Intl.NumberFormat("ja-JP", {
    style: "currency",
    currency: "JPY",
    currencyDisplay: "name",
  }).format(value)
}

/**
 * 数値をカンマ区切りして、ローカライズされた通貨記号を加えた文字列を返します。
 * @example
 * currencyNameFormat(12345); // -> ￥12,345
 */
export const currencySymbolFormat = (value: number) => {
  return new Intl.NumberFormat("ja-JP", {
    style: "currency",
    currency: "JPY",
    currencyDisplay: "symbol",
  }).format(value)
}
/**
 * @see https://github.com/tc39/proposal-Number.range
 *
 * @example
 * range(0, 3); // -> [0, 1, 2]
 * range(1, 3); // -> [1, 2]
 */
export function* range(start: number, end: number) {
  for (let i = start; i < end; i++) {
    yield i
  }
}
